import { IonContent, IonPage, IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Route, useLocation } from 'react-router';
import DashboardSideBar from '../../components/Dashboard/DashboardSideBar';
import ErrorPage from '../ErrorPage';
import GettingStarted from './pages/GettingStarted';
import CatalogPage from './pages/CatalogPage';
import OrdersPage from './pages/OrdersPage';
import EarningsPage from './pages/EarningsPage';
import Index from './pages/DashboardIndex/index';
import InventoryPage from './pages/InventoryPage/index';
import clsx from 'clsx';
import SettingsPage from './pages/SettingsPage';
import HelpAndSupportPage from './pages/HelpSupportPage/index';
import ChatPage from './pages/ChatPage';

export const dashboardPageStyle = clsx(
  'p-4 sm:p-6 w-full min-h-full space-y-4 sm:space-y-6 rounded-lg border border-border'
);

export default function Layout() {
  const location = useLocation();
  return (
    <IonPage>
      <IonContent>
        <div className="relative flex flex-row p-2 sm:py-4 xlg:py-2 sm:px-4 xlg:px-0 lg:gap-2 h-full w-full xlg:w-120 xlg:mx-auto overflow-hidden bg-[rgba(246,248,250,1)]">
          <DashboardSideBar match={location.pathname} />
          <div className="flex-1 flex flex-col gap-2">
            <div className=" flex-1 bg-white overflow-hidden rounded-lg dashboard">
              <div className="relative h-full">
                <IonRouterOutlet>
                  <Route
                    exact
                    path="/dashboard/get-started/"
                    component={GettingStarted}
                  />
                  <Route exact path="/dashboard" component={Index} />
                  <Route
                    exact
                    path="/dashboard/orders"
                    component={OrdersPage}
                  />
                  <Route
                    exact
                    path="/dashboard/catalog"
                    component={CatalogPage}
                  />
                  <Route
                    exact
                    path="/dashboard/inventory"
                    component={InventoryPage}
                  />
                  <Route
                    exact
                    path="/dashboard/earnings"
                    component={EarningsPage}
                  />
                  <Route path="/dashboard/chat" component={ChatPage} />
                  {/* <Route
                    exact
                    path="/dashboard/ads"
                    // component={AdsPage}
                    render={() => <ComingSoonPage title="Ads Management" />}
                  />
                  <Route
                    exact
                    path="/dashboard/airtime-data"
                    render={() => (
                      <ComingSoonPage title="Airtime and Data top-up" />
                    )}
                    // component={AirtimeDataPage}
                  /> */}
                  {/* <Route
                    exact
                    path="/dashboard/referral-program"
                    // component={ReferralPage}
                    render={() => <ComingSoonPage title="Referrals" />}
                  /> */}
                  <Route
                    path="/dashboard/help&support"
                    component={HelpAndSupportPage}
                  />
                  <Route path="/dashboard/settings" component={SettingsPage} />
                  <Route component={ErrorPage} />
                </IonRouterOutlet>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
